import styled from 'styled-components';

import { CTA } from '@/component-library';

const StyledCTA = styled(CTA)`
  align-self: flex-end;
`;

export { StyledCTA };
